// usePlatformBankAccounts — TanStack Query hook for /v1/platform/bank-accounts.
//
// Admin-only. Like useMerchants, this query is gated on the real JWT role
// (NOT the StrataTweaks dev role override) so it never fires for non-admins;
// they don't see the Platform sidebar section either.
import { useQuery } from "@tanstack/react-query";

import { listPlatformBankAccounts } from "@/api/platformBankAccounts";
import { useAuth, isAdminRole } from "@/store/auth";

export function usePlatformBankAccounts() {
  const status = useAuth((s) => s.status);
  const isAdmin = useAuth((s) => isAdminRole(s.user?.role));

  return useQuery({
    queryKey: ["platform-bank-accounts"],
    queryFn: listPlatformBankAccounts,
    enabled: status === "authenticated" && isAdmin,
    staleTime: 60_000,
  });
}
